import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import './index.css';
import { CommonStyledComponentProps } from '__utils/type';
import { useMediaQuery } from 'react-responsive';
import { isProUser } from '__utils/common-utils';
import { Mixpanel, getEventName } from '__utils/mixpanel';
import { SuccessButtonLAMF } from 'components/button';
import LAMFBannerSvgDesktop from 'images/LAMF_BannerDesktop.svg';
import LAMFBannerSvgMobile from 'images/LAMF_BannerMobile.svg';


const BannerBox = styled.div<CommonStyledComponentProps>`
    .mint-head{
        margin-bottom: 0;
        padding: ${(props: CommonStyledComponentProps) => !props.isMobile ? '24px 24px 0 24px' : '16px 16px 0 16px '} ;
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
    }
    .portfolio-grid{
        margin: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px 0' : '48px 0'};
        p{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '12px' : '16px'};
        }
        span{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '14px' : '16px'};
        }
    }
    .card-greyTxt{
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? '16px' : '24px'};
        small{
            font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? '12px' : '16px'};
        }
    }

    .lamf-button {
        margin-left : ${(props: CommonStyledComponentProps) => props.isMobile ? '12px' : '24px'};
        padding-bottom: 16px;
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '171px' : '100%'};
        padding-top: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '8px'};
    }

    .lamf-title {
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '214px' : ''};
        background: linear-gradient(90deg, #FCD3E9 0%, #D1AEFF 79.33%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-family: var(--app-style-heading, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-3xl, 24px)' : '20px'};
        font-style: normal;
        font-weight: 700;
        line-height: var(--app-line-height-lh-xl, 32px);
        align-self: ${(props: CommonStyledComponentProps) => props.isMobile ? 'left' : 'stretch'};
        padding: ${(props: CommonStyledComponentProps) => !props.isMobile ? '20px 24px 0 24px' : '10px 16px 0 16px '} ;
        padding-top: 16px;
    }
    .lamf-desc {
        align-self: stretch;
        padding: ${(props: CommonStyledComponentProps) => !props.isMobile ? '2px 24px 0 24px' : '1px 16px 0 16px '} ;
        color: var(--color-netural-000, #FFF);
        font-family: var(--app-style-micro, Roboto);
        font-size: ${(props: CommonStyledComponentProps) => props.isMobile ? 'var(--app-size-fs-md, 16px)' : 'var(--app-size-fs-md, 14px)'}
        font-style: normal;
        font-weight: 500;
        line-height: var(--app-line-height-lh-sm, 20px);
        letter-spacing: 0.034px;
        margin-bottom : ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '-21px'} ;
        margin-top : ${(props: CommonStyledComponentProps) => props.isMobile ? '2px' : ''};
        width: ${(props: CommonStyledComponentProps) => props.isMobile ? '254px' : '300px'}; 
    }

    .lamf {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        border-radius: var(--radius-md, 8px);
        position: relative;
        background-image: ${(props: CommonStyledComponentProps) => props.isMobile ? `url(${LAMFBannerSvgMobile})` : `url(${LAMFBannerSvgDesktop})`} ; 
        background-position: right;
        background-size: cover;
        background-repeat: no-repeat;
        height: ${(props: CommonStyledComponentProps) => props.isMobile ? '' : '168px'};
    }

    
`;

interface LAMFProps {
    openThankYouPopup: () => void;
}

const LAMFBanner : React.FC<LAMFProps> = ({openThankYouPopup}) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const registerDp = () => {
        Mixpanel.track(getEventName('LAMF-Banner', 'clicked', 'home'))
        openThankYouPopup();
    }

    const getLAMFButton = () => {
        return (
            <div className={isMobile ? '' : "mt36"}>
                <div className={!isMobile ? 'grid-center ' : 'mt16'}>
                    <SuccessButtonLAMF onClick={registerDp}>I'm Interested</SuccessButtonLAMF>
                </div>
            </div>
        )
    }

    return (
        <>
          {isProUser() && (
            <BannerBox isMobile={isMobile}>
                <div className={`lamf mt30 ${isMobile ? 'm16' : ''}`}>
                    <p className="lamf-title ">Loan Against Mutual Funds</p>
                    <p className="lamf-desc">Get a free call from our experts and earn an extra 0.5% on loans over ₹5L!</p>     
                    <p className="lamf-button">{getLAMFButton()}</p>
              </div>
            </BannerBox>
          )}
        </>
      );
}

export default LAMFBanner;